import Link from "next/link";

export function PrimaryButton({
  href,
  children,
  className = "",
  ...props
}: React.ComponentProps<"button"> & { href?: string; className?: string }) {
  if (href) {
    return (
      <Link href={href} className={`btn-primary ${className}`}>
        {children}
      </Link>
    );
  }
  return (
    <button type="button" className={`btn-primary ${className}`} {...props}>
      {children}
    </button>
  );
}

export function GhostButton({
  href,
  children,
  className = "",
  ...props
}: React.ComponentProps<"button"> & { href?: string; className?: string }) {
  if (href) {
    return (
      <Link href={href} className={`btn-ghost ${className}`}>
        {children}
      </Link>
    );
  }
  return (
    <button type="button" className={`btn-ghost ${className}`} {...props}>
      {children}
    </button>
  );
}
